/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_View_Diet_BodyInputs */

const en_portal_view_diet_body = /** @type {(inputs: Portal_View_Diet_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your coach sets the calorie target. You photograph your plate and the rest adds itself up.`)
};

const pl_portal_view_diet_body = /** @type {(inputs: Portal_View_Diet_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener ustawia cel kalorii. Ty robisz zdjęcie talerza, a reszta liczy się sama.`)
};

/**
* | output |
* | --- |
* | "Your coach sets the calorie target. You photograph your plate and the rest adds itself up." |
*
* @param {Portal_View_Diet_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_view_diet_body = /** @type {((inputs?: Portal_View_Diet_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_View_Diet_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_view_diet_body(inputs)
	return en_portal_view_diet_body(inputs)
});